import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Tag, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import useCompanyNavigate from '../../utils/useCompanyNavigate';
import { departmentApi, photoTypeApi } from '../../services/api';

const Departments = () => {
  const navigate = useCompanyNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [photoTypeMap, setPhotoTypeMap] = useState({});

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      const [deptRes, ptRes] = await Promise.all([
        departmentApi.list({ page, limit: pagination.pageSize }),
        photoTypeApi.all(),
      ]);
      if (deptRes.success) {
        setData(deptRes.data.list);
        setPagination(prev => ({ ...prev, current: page, total: deptRes.data.pagination.total }));
      }
      const map = {};
      (ptRes.data || []).forEach(pt => { map[pt.id] = pt.name; });
      setPhotoTypeMap(map);
    } catch (error) {
      message.error('获取部门列表失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    try {
      await departmentApi.delete(id);
      message.success('删除成功');
      fetchData(pagination.current);
    } catch (error) {
      message.error(error.response?.data?.message || '删除失败');
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '部门名称', dataIndex: 'name' },
    {
      title: '照片类型',
      dataIndex: 'photo_types',
      render: (types) => types ? types.split(',').map(t => (
        <Tag key={t} color="volcano">{photoTypeMap[t] || `类型${t}`}</Tag>
      )) : '-'
    },
    {
      title: '可创建批次',
      dataIndex: 'can_create_batch',
      render: (v) => v === 1 ? <Tag color="green">是</Tag> : <Tag color="default">否</Tag>
    },
    {
      title: '状态',
      dataIndex: 'status',
      render: (status) => <Tag color={status === 1 ? 'green' : 'red'}>{status === 1 ? '启用' : '禁用'}</Tag>
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EditOutlined />} onClick={() => navigate(`/admin/departments/${record.id}/edit`)}>
            编辑
          </Button>
          <Popconfirm title="确定删除该部门吗？" onConfirm={() => handleDelete(record.id)}>
            <Button type="link" danger icon={<DeleteOutlined />}>删除</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <Button icon={<ReloadOutlined />} onClick={() => fetchData(pagination.current)}>刷新</Button>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/admin/departments/new')}>
          新增部门
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="id"
        pagination={{ ...pagination, onChange: (page) => fetchData(page) }}
      />
    </div>
  );
};

export default Departments;
